// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"5efe1347","509":"faf7f533","689":"16275c09","758":"85dd40c2","838":"38452522","995":"3ac1d8c0"}[chunkId] + ".chunk.css";
};